import React, { Component } from "react"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../localization/strings"
import { IMassJobEdit } from "../../models"

interface IProps {
    onClose: () => void
    massJobEditData: IMassJobEdit
    handleSave: () => void
}

const JobMassShiftEditConfirmationDialog = ({ massJobEditData, onClose, handleSave }: IProps) => {
    return (
        <Dialog
            open
            title={strings.Confirm_Changes}
            titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
            autoScrollBodyContent={true}
            actions={[<FlatButton label={strings.CANCEL} secondary onClick={onClose} />, <FlatButton label={strings.SAVE} primary onClick={handleSave} />]}
        >
            <div style={{ padding: 10 }}>
                {massJobEditData.ChangeShiftStartTime && (
                    <p>
                        {strings.Start_Time}:{" "}
                        {`${massJobEditData.StartTime.Hour > 12 ? massJobEditData.StartTime.Hour - 12 : massJobEditData.StartTime.Hour}:${
                            massJobEditData.StartTime.Minute === 0 ? "00" : massJobEditData.StartTime.Minute
                        }${massJobEditData.StartTime.Hour > 12 ? "pm" : "am"}`}
                    </p>
                )}
                {massJobEditData.ChangeShiftEndTime && (
                    <p>
                        {strings.End_Time}:{" "}
                        {`${massJobEditData.EndTime.Hour > 12 ? massJobEditData.EndTime.Hour - 12 : massJobEditData.EndTime.Hour}:${
                            massJobEditData.EndTime.Minute === 0 ? "00" : massJobEditData.EndTime.Minute
                        }${massJobEditData.EndTime.Hour > 12 ? "pm" : "am"}`}
                    </p>
                )}
                {massJobEditData.ChangeJobStatus && (
                    <p>
                        {strings.Status}: {`${massJobEditData.JobStatus && massJobEditData.JobStatus.Name} ${massJobEditData.JobStatus && massJobEditData.JobStatus.JobSubStatus ? '- ' + massJobEditData.JobStatus.JobSubStatus.Name : ""}`}
                    </p>
                )}
                {massJobEditData.CanAddNote && (
                    <p>
                        {strings.Note}: {massJobEditData.Note}
                    </p>
                )}
                {massJobEditData.ChangeActiveStatus && (
                    <p>
                        {strings.Active_Status}: {massJobEditData.Active ? strings.Active : strings.Inactive}
                    </p>
                )}
            </div>
        </Dialog>
    )
}

export default JobMassShiftEditConfirmationDialog
